
import {defineComponent, PropType} from 'vue';
import iMovie from "@/interfaces/iMovie";
import {imgUrl} from "@/service/MoviesService";

import 'vue3-carousel/dist/carousel.css';
// eslint-disable-next-line
// @ts-ignore
import {Carousel, Slide, Pagination} from 'vue3-carousel';
import MovieRating from "@/components/MovieRating.vue";


export default defineComponent({
  name: "MoviesBanner",
  components: {MovieRating, Carousel, Slide, Pagination},
  emits: ['onOpenModal'],
  props: {
    movies: {
      type: Object as PropType<iMovie>,
      required: false
    }
  },
  setup(props, {emit}) {
    const openModal = (movieId: number): void => {
      emit('onOpenModal', movieId);
    }

    const carouselSettings = {
      itemsToShow: 1,
      snapAlign: 'center',
      wrapAround: true,
      autoplay: 4000,
      pauseAutoplayOnHover: true
    }
    return {
      openModal,
      carouselSettings,
      imgUrl
    }
  }
})
